module.exports = __webpack_public_path__ + "img/gallery.a79351a.svg";